var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-cover"},[_c('div',{staticClass:"modal-window"},[_vm._t("default")],2),_c('span',{staticClass:"material-icons modal-close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n    clear\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }